/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DiscountValueType = {
    Percentage: 'Percentage',
    FixedAmount: 'FixedAmount'
} as const;
export type DiscountValueType = typeof DiscountValueType[keyof typeof DiscountValueType];


export function instanceOfDiscountValueType(value: any): boolean {
    for (const key in DiscountValueType) {
        if (Object.prototype.hasOwnProperty.call(DiscountValueType, key)) {
            if (DiscountValueType[key as keyof typeof DiscountValueType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DiscountValueTypeFromJSON(json: any): DiscountValueType {
    return DiscountValueTypeFromJSONTyped(json, false);
}

export function DiscountValueTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountValueType {
    return json as DiscountValueType;
}

export function DiscountValueTypeToJSON(value?: DiscountValueType | null): any {
    return value as any;
}

export function DiscountValueTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DiscountValueType {
    return value as DiscountValueType;
}

